module.exports = __webpack_public_path__ + "img/debug-example.ffcabee6.png";